
import ability from '@/libs/acl/ability'
export const getDefaultState = () => ({
  Username: '',
  UserType: 'Type',
  Rights: [],
  UserSessionToken: '',
  callCount: 0,
})

export default {
  state: getDefaultState(),
  mutations: {
    USER_CLEAR(state) {
      Object.assign(state, getDefaultState())
    },
    USER_SET(state, payload) {
      state.Username = payload.Username
    },
    USER_SET_CALLCOUNT(state, payload) {
      state.callCount = payload
    },
    USER_SESSION_TOKEN(state, token) {
      state.UserSessionToken = token
      this._vm.$http.defaults.headers['jwt'] = token
    },
    USER_SET_COOKIE(state, token) {
      this._vm.$cookies.set('jwt', token, '7d')
      state.UserSessionToken = token
      this._vm.$http.defaults.headers['jwt'] = token
    },
    USER_SET_RIGHTS(state, r) {
      state.Rights = r
    },
  },
  actions: {
    LOGOUT({ state, commit }) {
      return new Promise((resolve, reject) => {
        this._vm.$http.post('authentication/logout', {
          jwt : this._vm.$http.defaults.headers['jwt'],
        })
        this._vm.$cookies.remove('jwt')
        delete this._vm.$http.defaults.headers['jwt']
        commit('USER_CLEAR')
        resolve()
        console.log("Logout")
      })
    },
    SET_RIGHTS(context, r) {
      return new Promise((resolve, reject) => {
        context.commit('USER_SET_RIGHTS', r)
        resolve()
      })
    },
    SET_TOKEN(context, token) {
      return new Promise((resolve, reject) => {
        context.commit('USER_SESSION_TOKEN', token)
        resolve()
      })
    },
    SET_CALLCOUNT(context, count) {
      return new Promise((resolve, reject) => {
        context.commit('USER_SET_CALLCOUNT', count)
        resolve()
      })
    },
    LOGIN(context, loginData) {
      return new Promise((resolve, reject) => {
        this._vm.$http.post('/authentication/login',  JSON.stringify({
          username: loginData.Username,
          password: loginData.Password
        }))
          .then(resp => {
            if(resp.data.success) {
              let r = [];
              let rAbility = [];
              r.push("R" + 0)
              rAbility.push({
                action: 'read',
                subject: 'R'+0,
              })

              Object.keys(resp.data.user.Rights).forEach(key => {
                r.push("R" + key)
                rAbility.push({
                  action: 'read',
                  subject: 'R'+key,
                })
              })

              context.commit('USER_SET_RIGHTS', r)
              ability.update(rAbility)

              context.commit('USER_SESSION_TOKEN', resp.data.token)
              if(loginData.RememberMe) {
                context.commit('USER_SET_COOKIE', resp.data.token)
              }
              resolve({success: true})
            } else {
              resolve({success: false})
            }
          })
          .catch(err => {
            console.error(err)
            reject(err)
          })
      })
    },
  },
  modules: {},
}
